import { useEnvState } from '../../context/env';
import { useAuthState } from '../../context/auth';
import { topicsAPI } from '../../context/topics';
import { clone } from '../utils/helpers';
import { useLog } from './useLog';
const usePostManager = () => {
  const envState = useEnvState();
  const authState = useAuthState();
  const handlePost = async ({
    data,
    topic,
    reply,
    slug,
    edit,
    isTypeTopic,
    messageBusUtil,
    messageBusDispatch,
    updateTopicPost,
    updateTopicReplies,
    trackForum
  }) => {
    try {
      const productSlug = envState.product;
      const {
        log
      } = useLog();
      let response = {};
      if (edit) {
        if (isTypeTopic) {
          var _topic$first;
          // update first post
          const postId = topic === null || topic === void 0 || (_topic$first = topic.first) === null || _topic$first === void 0 || (_topic$first = _topic$first.post) === null || _topic$first === void 0 ? void 0 : _topic$first.id;
          if (!postId) throw 'topic id not defined';
          response = await topicsAPI.updateReply(envState.base_url, authState.api_key, postId, data);
          /* The following function is used elsewhere to just call updateTopicPostComments
           * at the bottom of this file... This could possibly be improved with
           * some smarter usage of context... */
          updateTopicPost && updateTopicPost(topic.id, response.post);
        } else {
          // edit reply
          response = await topicsAPI.updateReply(envState.base_url, authState.api_key, reply === null || reply === void 0 ? void 0 : reply.id, data);
          updateTopicReplies && updateTopicReplies(response);
        }
      } else {
        // creating a new post
        let dispatchType = 'ADD_ITEM_TO_MY_TOPICS';
        const event = {};
        event.type = 'topics';
        event.deactivate = [{
          whichList: 'topics',
          message_type: 'new_topic'
        }, {
          whichList: 'replies',
          message_type: 'latest'
        }];
        if (!isTypeTopic) {
          data.topic_id = topic !== null && topic !== void 0 && topic.id ? topic === null || topic === void 0 ? void 0 : topic.id : reply === null || reply === void 0 ? void 0 : reply.topic_id;
          dispatchType = 'ADD_ITEM_TO_MY_REPLIES';
          event.type = 'replies';
          event.deactivate = [{
            whichList: 'replies',
            message_type: 'latest'
          }];
        }
        if (isTypeTopic && slug) {
          data['tags'] = [slug, productSlug];
        }

        // set update in progess flag BEFORE making API call that creates topic/reply
        messageBusDispatch({
          type: 'SET_UPDATE_IN_PROGRESS',
          payload: true
        });

        // create topic or reply
        response = await topicsAPI.createTopicReply(envState.base_url, authState.api_key, data);
        log('MessageBus', 'new topic/reply response', response);
        if (response) {
          event.topic_id = response.topic_id;
          event.dispatch_type = dispatchType;
          let payload = messageBusUtil.createPayload({
            reply_id: response.id,
            topic_id: response.topic_id,
            message_type: dispatchType
          });

          // add topic or reply item, then add event indicating this post was made by current user
          messageBusDispatch({
            type: dispatchType,
            payload: payload
          });
          messageBusDispatch({
            type: 'ADD_EVENT',
            payload: event
          });
          trackForum && trackForum({
            interaction: isTypeTopic ? 'topic' : 'reply'
          });
        }
        updateTopicReplies && updateTopicReplies(response);
      }
      return response;
    } catch (err) {
      console.log('Error while handling post', err);
      return {};
    }
  };
  const getDigestInfo = async topics => {
    const digestResponse = await topicsAPI.getTopicsDigest(envState.base_url, authState.api_key, topics.map(topic => topic.id));
    if (digestResponse) {
      topics.forEach(topic => {
        let thisTopicDigest = digestResponse[String(topic.id)];
        topic.original_poster = thisTopicDigest.original_poster;
        topic.first = thisTopicDigest.first;
        topic.recent = thisTopicDigest.recent;
      });
    }
    return topics;
  };
  const updateTopicPostContents = (id, post, topicsList, setTopicsList) => {
    const updatedTopicId = id;
    const list = clone(topicsList);
    for (let i = 0; i < list.length; i++) {
      if (updatedTopicId === list[i].id) {
        const now = new Date();
        list[i].last_posted_at = now.toISOString();
        list[i].first.post.cooked = post.cooked;
        list[i].first.post.raw = post.raw;
        setTopicsList(list);
        break;
      }
    }
  };
  return {
    handlePost,
    getDigestInfo,
    updateTopicPostContents
  };
};
export { usePostManager };
//# sourceMappingURL=usePostManager.js.map